import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import theme from '../../common/theme';

const SubPageTitle = ({ title }) => (
  <>
    <Grid container justify="center" alignItems="center">
      <div style={{ width: isMobile ? '100%' : '1200px' }}>
        <Typography
          className="noselect"
          variant="h6"
          style={{
            fontWeight: 'bold',
            padding: '10px',
            background: '#f4f4f4',
            height: '50px',
            width: '200px',
            textAlign: 'center',
            borderTop: `3px solid ${theme.palette.primary.light}`,
            borderLeft: '1px solid #ddd',
            borderRight: '1px solid #ddd',
          }}
        >
          {title}
        </Typography>
      </div>
    </Grid>
    <hr style={{ marginTop: '0px', marginBottom: '0px' }} />
  </>
);

export default SubPageTitle;
